"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.8124 25C16.8124 24.3696 16.6254 23.7533 16.2752 23.2291C15.9249 22.7049 15.4271 22.2964 14.8447 22.0551C14.2622 21.8139 13.6213 21.7507 13.003 21.8737C12.3847 21.9967 11.8168 22.3003 11.371 22.7461C10.9252 23.1919 10.6216 23.7598 10.4986 24.3781C10.3756 24.9964 10.4388 25.6373 10.68 26.2198C10.9213 26.8022 11.3298 27.3 11.854 27.6503C12.3782 28.0005 12.9945 28.1875 13.6249 28.1875C14.4703 28.1875 15.281 27.8517 15.8788 27.2539C16.4766 26.6561 16.8124 25.8454 16.8124 25Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.1874 25C28.1874 24.3696 28.0004 23.7533 27.6502 23.2291C27.2999 22.7049 26.8021 22.2964 26.2197 22.0551C25.6372 21.8139 24.9963 21.7507 24.378 21.8737C23.7597 21.9967 23.1918 22.3003 22.746 22.7461C22.3002 23.1919 21.9966 23.7598 21.8736 24.3781C21.7506 24.9964 21.8138 25.6373 22.055 26.2198C22.2963 26.8022 22.7048 27.3 23.229 27.6503C23.7532 28.0005 24.3695 28.1875 24.9999 28.1875C25.8436 28.182 26.6512 27.8444 27.2477 27.2479C27.8443 26.6513 28.1819 25.8437 28.1874 25Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.5832 25C39.5832 24.3687 39.3957 23.7516 39.0445 23.227C38.6934 22.7023 38.1943 22.2938 37.6107 22.0532C37.027 21.8126 36.385 21.7507 35.7662 21.8753C35.1473 22 34.5794 22.3057 34.1344 22.7536C33.6895 23.2014 33.3876 23.7713 33.2669 24.391C33.1463 25.0107 33.2124 25.6522 33.4569 26.2343C33.7013 26.8164 34.1131 27.3127 34.64 27.6605C35.1669 28.0082 35.7852 28.1916 36.4165 28.1875C37.2583 28.182 38.0637 27.8437 38.657 27.2466C39.2503 26.6494 39.5832 25.8418 39.5832 25Z",
    fill: fill
  }));
};

exports["default"] = _default;